import React from "react";
import "./../PG-CSS/paymentGateway.css";
import PaymentStatusComp from "../components/PaymentStatusComp";
import CancellationScreenComp from "../components/CancellationScreenComp";
import { startPaymentSession } from "../actions/paymentGateway";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import WithLayout from "../../trialUsers/container/wrapperLogo";

const StripePaymentStatusCont = (props) => {
   const { subscription_interval } = props;
   const isSuccess = window.location.search.includes("success=true");
   const createStripePayment = () => {
      startPaymentSession(subscription_interval);
   };

   return (
      <WithLayout showNeedHelp={false} removeMargin={true}>
         <div className="trial-new-flow-background-payment-link" />
         {isSuccess ? <PaymentStatusComp /> : <CancellationScreenComp createStripePayment={createStripePayment} />}
      </WithLayout>
   );
};

const mapStateToProps = (state) => ({
   subscription_interval: state?.auth?.subscriptionInterval,
});

export default withRouter(connect(mapStateToProps)(StripePaymentStatusCont));
